<template>
  <div class="finish_page" v-if="isDone">
    <img class="i" src="../assets/img/contract/succ-blue@3x.png" />
    <div class="t">合同签署成功</div>
  </div>
  <iframe class="ifr" :style="{ height: `${height}px` }" :src="signingUrl" v-else-if="signingUrl" />
</template>

<script>
import req from '../req';

export default {
  data() {
    return {
      isDone: false,
      signingUrl: '',
      height: window.innerHeight,
    };
  },
  created() {
    this.checkStatus();
  },
  methods: {
    async checkStatus() {
      const { id } = this.$route.query;
      if (!id) {
        this.isDone = true;
        return;
      }
      try {
        const res = await req.contract.getContractSignature({
          contractNo: id,
        });
        if (res.code !== 0) {
          throw res;
        }
        const { signFinish, signingUrl } = res.data;
        if (signFinish) {
          this.isDone = true;
          return;
        }
        this.signingUrl = signingUrl;
        // window.location.href = signingUrl;
      } catch (err) {
        req.err.show(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.finish_page {
  padding-top: 4rem;

  .i {
    display: block;
    width: 4.4rem;
    height: 4.4rem;
    margin: auto;
  }

  .t {
    margin-top: 1rem;
    font-weight: 500;
    font-size: 1rem;
    color: #212732;
    text-align: center;
  }
}

.ifr {
  display: block;
  width: 100vw;
  border: none;
}
</style>
